import React, { useState, useEffect } from 'react';
import './App.css';


const Footer = () => {
  return(
  <footer className="footer-container">
        <div className="footer-background"></div>
        <div className="max-width" style={{ position: 'relative', zIndex: 10 }}>
          <div className="footer-grid">

            <div className="footer-brand">
              <div className="footer-brand-container">
                <div className="footer-brand-logo">
                  <span className="footer-brand-logo-text"></span>
                </div>
                <div>
                  <span className="footer-brand-name">SlickRock Painting</span>
                  <p className="footer-brand-subtext">SOUTHERN UTAH</p>
                </div>
              </div>
              <p className="footer-brand-description">
                Transforming Southern Utah homes with cutting-edge painting solutions designed for the desert's most demanding conditions.
              </p>
              <div className="footer-brand-tags">
                <div className="footer-brand-tag">Licensed & Insured</div>
                <div className="footer-brand-dot"></div>
                <div className="footer-brand-tag">Multi-Year Warranty</div>
                <div className="footer-brand-dot"></div>
                <div className="footer-brand-tag">5★ Rated</div>
              </div>
            </div>
            
            <div>
              <h4 className="footer-section-title">Services</h4>
              <ul className="footer-link-list">
                <li className="footer-link">Exterior Painting</li>
                <li className="footer-link">Interior Design</li>
                <li className="footer-link">Commercial Projects</li>
                <li className="footer-link">Cabinet Refinishing</li>
                <li className="footer-link">Specialty Finishes</li>
              </ul>
            </div>
            
            <div>
              <h4 className="footer-section-title">Areas Served</h4>
              <ul className="footer-link-list">
                <li className="footer-link">St. George</li>
                <li className="footer-link">Cedar City</li>
                <li className="footer-link">Hurricane</li>
                <li className="footer-link">Washington</li>
                <li className="footer-link">Ivins</li>
              </ul>
            </div>
          </div>
          
          <div className="footer-bottom">
            <div className="footer-copyright">
              © 2025 SlickRock Painting Co. All rights reserved.
            </div>
            <div className="footer-bottom-links">
              <button className="footer-bottom-link">Privacy Policy</button>
              <button className="footer-bottom-link">Terms of Service</button>
              <button className="footer-bottom-link">Careers</button>
            </div>
          </div>
        </div>
      </footer>
 );
}

export default Footer;

